import callApi from 'lib/callApi';

export function getExportCsvUrlParams(
  companyId: number,
  ordering: string,
  filter: string,
  searchData: string,
  checkedHostIds: number[],
) {
  if (companyId === -1) return '';
  const params = {
    company_id: companyId,
    filter: filter,
    search: searchData,
  };
  if (checkedHostIds?.length > 0) {
    params['host_id_list'] = checkedHostIds;
  }
  if (ordering && ordering !== 'name') {
    params['ordering'] = `${ordering},name`;
  }

  return params;
}

export async function loadWebAppsData(
  company_id: number,
  pageSize: number,
  currentPage: number,
  ordering: string,
  search_data: string,
  filter: string,
): Promise<any> {
  if (company_id === undefined) {
    throw Error('company_id is required.');
  }

  // if company_id is not yet available then do not proceed further
  if (company_id === -1) return;

  if (ordering && ordering !== 'name') ordering = `${ordering},name`;

  const url = `web_apps/?company_id=${company_id}&search=${search_data}&offset=${
    pageSize * (currentPage - 1)
  }&limit=${pageSize}&ordering=${ordering}&filter=${filter}`;

  const data = await callApi(url, 'GET', {})
    .then((res) => {
      // TODO: return data
      if ((res.status === 201 || res.status === 200) && res.data.results) {
        return {
          items: res.data.results,
          count: res.data.count,
          insights: res.data.insights,
        };
      } else {
        // eslint-disable-next-line no-console
        console.error({
          function: 'loadWebAppsData',
          error: `Unexpected response: ${res.status}`,
          res,
        });
      }
    })
    .catch((err) => {
      // TODO: log error
      throw err;
    });

  return data;
}

export async function fetchWADetail(id, company_id) {
  const url = `web_apps/${id}?company_id=${company_id}`;
  const data = await callApi(url, 'GET', {})
    .then((res) => {
      if (res.data) {
        return res.data;
      }
    })
    .catch((err) => {
      throw err;
    });
  return data;
}

export const processJsonData = (json: any) => {
  if (!json) return;

  // process webapp owner
  const webappOwner = JSON.parse(json['webapp_owner']);
  let processedOwner = null;
  if (webappOwner && Object.keys(webappOwner).length) {
    processedOwner = {
      ...webappOwner,
      fullname:
        webappOwner['firstName'] && webappOwner['lastName']
          ? webappOwner['firstName'] + ' ' + webappOwner['lastName']
          : null,
    };
  }

  // process comments
  const commentsList = json['detail']['comments']?.list;
  const processedComments =
    commentsList && commentsList.length
      ? commentsList.map((commentObj) => {
          const comment = commentObj['Comment'];
          const username = comment['author']['username'];

          return {
            Comment: {
              ...comment,
              username,
            },
          };
        })
      : null;

  // process createdBy
  const createdBy = json['detail']['createdBy'];
  let processedCreatedBy = null;
  if (createdBy) {
    processedCreatedBy = {
      ...createdBy,
      fullname:
        createdBy['firstName'] && createdBy['lastName']
          ? createdBy['firstName'] + ' ' + createdBy['lastName']
          : null,
    };
  }

  // process updatedBy
  const updatedBy = json['detail']['updatedBy'];
  let processedUpdatedBy = null;
  if (updatedBy) {
    processedUpdatedBy = {
      ...updatedBy,
      fullname:
        updatedBy['firstName'] && updatedBy['lastName']
          ? updatedBy['firstName'] + ' ' + updatedBy['lastName']
          : null,
    };
  }

  const processedJson = {
    ...json,
    webapp_owner: processedOwner,
    detail: {
      ...json['detail'],
      comments: {
        list: processedComments,
      },
      createdBy: processedCreatedBy,
      updatedBy: processedUpdatedBy,
    },
  };

  return processedJson;
};
